"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
var _check = _interopRequireDefault(require("../../icons/check"));
var _warningSolid = _interopRequireDefault(require("../../icons/warning-solid"));
require("./field-status.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var renderIcon = function renderIcon(error) {
  if (error === false || error === true) {
    return /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      className: "fieldStatus__icon",
      path: error ? _warningSolid["default"] : _check["default"],
      size: "20px"
    });
  }
};

/**
 * Displays validation messages for form fields. Used by default to show errors in components
 * that use the FieldBase (Field, Select).
 */
var FieldStatus = function FieldStatus(props) {
  var className = props.className,
    error = props.error;
  var classList = (0, _classnames["default"])('fieldStatus text-xxs', _defineProperty({
    'fieldStatus--indeterminate': !(error === false || error === true),
    'fieldStatus--error': error,
    'fieldStatus--valid': !error
  }, className, Boolean(className)));
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: classList
  }, renderIcon(error), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fieldStatus__text"
  }, props.children));
};
FieldStatus.displayName = 'FieldStatus';
FieldStatus.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  /**
   * Current error status. Pass `true` to mark as an error, `false` to mark that the field is valid,
   * or leave undefined for an indeterminate default state.
   */
  error: _propTypes["default"].bool
} : {};
var _default = exports["default"] = FieldStatus;